import { useCallback, useState } from 'react';
import { SnackbarSeverityEnum } from '../enums/snackbar-severity-enum';

const useSnackbar = () => {
  const [snackbar, setSnackbar] = useState<{
    message: string;
    open: boolean;
    severity: SnackbarSeverityEnum;
  }>({
    message: '',
    open: false,
    severity: SnackbarSeverityEnum.ERROR,
  });

  const showSnackbar = useCallback(
    (message: string, severity: SnackbarSeverityEnum) => {
      setSnackbar({
        message,
        open: true,
        severity,
      });
    },
    []
  );

  const closeSnackbar = useCallback(() => {
    setSnackbar(prevState => ({
      ...prevState,
      open: false,
    }));
  }, []);

  return {
    snackbar,
    showSnackbar,
    closeSnackbar,
  };
};

export default useSnackbar;
